import styled from 'styled-components';

import { PaletteColor } from '@utils/types';

export const Label = styled.span<{
  backgroundColor?: PaletteColor;
  color?: PaletteColor;
  fontWeight?: string;
  borderColor?: PaletteColor;
}>`
  width: auto;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 600;
  text-align: center;
  padding: 15px 12px;
  background-color: ${({ backgroundColor, theme }) =>
    backgroundColor
      ? theme.palette[backgroundColor as PaletteColor]
      : theme.palette.lightSuccess};

  color: ${({ color, theme }) =>
    color ? theme.palette[color as PaletteColor] : theme.palette.darkSuccess};

  ${({ fontWeight }) => fontWeight && `font-weight: ${fontWeight}`}
  font-size: 14px;
  border: dashed 0.5px
    ${({ theme, borderColor }) =>
      borderColor
        ? theme.palette[borderColor as PaletteColor]
        : theme.palette.darkSuccess};
`;
